module.exports = __webpack_public_path__ + "img/tezos.5c7c7797.png";